<template>
  <div class="dashboard-charts">
    <div class="client-banner-justeat" v-if="client == 'just-eat'"></div>
    <div class="client-banner-matalan" v-else-if="client == 'matalan'"></div>

    <div class="model-list" ref="ModelButton">
      <button @click="toggleModel()" rel="togglebtnModel" class="btn toggle-model">
        <span>
          <i class="fa fa-th-large" aria-hidden="true"></i>
        </span>
        <b>Select a model</b>
      </button>

      <div class="dropdown-content hide-model-content" ref="Modelmenu">
        <p
          v-for="(currentjob, key) in joblist"
          :key="key"
          v-bind:value="currentjob.id"
          v-on:click="selectedJob(currentjob.id);toggleModel()"
          v-bind:class="currentjobobj.id == currentjob.id ? 'current-model' : ''"
        >{{ currentjob.name }} | {{currentjob.id}}</p>
      </div>

      <div class="model-name">{{ currentjobobj.name }} | {{currentjobobj.id}}</div>

      <div class="csv-reports">
        <span @click="goToReports()">
          Go to CSV Reports
          <i class="fa fa-chevron-right chevron-right-icon" aria-hidden="true"></i>
        </span>
      </div>
    </div>

    <div class="line-chart">
      <div class="cardheader line-chart-header">
        <strong>{{chart1}}</strong>

        <div class="downloadbtn">
          <a
            ref="downcsvWebTrafficOverviewModel"
            v-if="downcsvWebTrafficOverviewurl.length"
            v-bind:href="downcsvWebTrafficOverviewurl"
            class="btn btn-lrg btn-primary downcsvtrigger"
            download
          >
            <i class="fa fa-file-excel-o"></i> Download CSV
          </a>
        </div>
      </div>
      <div class="card">
        <div class="dataspinner" v-if="isInChartDataLoad">
          <div class="bounce1 makecenter"></div>
          <div class="bounce2 makecenter"></div>
          <div class="bounce3 makecenter"></div>
        </div>
        <div v-else-if="isInChartData">
          <button v-if="zoomed" @click="zoomTest()" class="zoomreset">Reset Zoom</button>
          <linechart
            ref="linechart"
            :chartData="inchartdata"
            :width="width"
            :height="height"
            :options="options"
          ></linechart>
        </div>
        <div class="datanotfound" v-else>
          <h1>Sorry, Data not found.</h1>
        </div>
      </div>
    </div>

    <div class="chartrow">
      <div class="column">
        <div class="cardheader">
          <strong>{{chart2}}</strong>
          <div class="downloadbtn">
            <a
              ref="downcsvTouchpointHitsModel"
              v-if="downcsvTouchpointHitsurl.length"
              v-bind:href="downcsvTouchpointHitsurl"
              class="btn btn-lrg btn-primary downcsvtrigger"
              download
            >
              <i class="fa fa-file-excel-o"></i> Download CSV
            </a>
          </div>
        </div>
        <div class="bar-chart-withbtn" v-if="isTouchpointData">
          <div class="togglebutton2">
            <span>
              <input
                id="yes"
                value="yes"
                type="radio"
                name="touchpointAlluser"
                :selected="touchpointAllusercheck === true ? true : false"
              >
              <label
                @click="touchpointAlluser()"
                for="yes"
                v-bind:class="touchpointAllusercheck === true ? 'active' : ''"
              >All</label>
            </span>
            <span>
              <input
                id="no"
                type="radio"
                value="no"
                name="touchpointAlluser"
                :selected="touchpointAllusercheck === true ? false : true"
              >
              <label
                @click="touchpointReturninguser()"
                for="no"
                v-bind:class="touchpointAllusercheck === true ? '' : 'active'"
              >Converted</label>
            </span>
          </div>
        </div>
        <div class="bar-chart">
          <div class="dataspinner" v-if="isTouchpointDataLoad">
            <div class="bounce1 makecenter"></div>
            <div class="bounce2 makecenter"></div>
            <div class="bounce3 makecenter"></div>
          </div>
          <div v-else-if="isTouchpointData">
            <barchart
              ref="barchart"
              :chartData="touchpointdata"
              :width="width"
              :height="height"
              :options="chartoptions"
              :bind="true"
            ></barchart>
          </div>
          <div class="datanotfound" v-else>
            <h1>Sorry, Data not found.</h1>
          </div>
        </div>
      </div>

      <div class="column">
        <div class="cardheader">
          <strong>{{chart3}}</strong>
          <div class="downloadbtn">
            <a
              ref="downcsvLookbackModel"
              v-if="downcsvLookbackurl.length"
              v-bind:href="downcsvLookbackurl"
              class="btn btn-lrg btn-primary downcsvtrigger"
              download
            >
              <i class="fa fa-file-excel-o"></i> Download CSV
            </a>
          </div>
        </div>
        <div class="bar-chart bar-chart-withbtn">
          <div class="togglebutton" v-if="showbutton">
            <span>
              <input
                id="yes"
                value="yes"
                type="radio"
                name="existing_channel_groupings"
                :selected="existing_channel_range === 'yes' ? true : false"
                v-model="existing_channel_range"
              >
              <label
                @click="fifteenDaysData()"
                for="yes"
                v-bind:class="existing_channel_range === 'yes' ? 'active' : ''"
              >15 Days</label>
            </span>
            <span>
              <input
                id="no"
                type="radio"
                value="no"
                name="existing_channel_groupings"
                :selected="existing_channel_range === 'yes' ? false : true"
                v-model="existing_channel_range"
              >
              <label
                @click="thirtyDaysData()"
                for="no"
                v-bind:class="existing_channel_range === 'yes' ? '' : 'active'"
              >30 Days</label>
            </span>
          </div>
          <div class="dataspinner" v-if="isReturningUsersDataLoad">
            <div class="bounce1 makecenter"></div>
            <div class="bounce2 makecenter"></div>
            <div class="bounce3 makecenter"></div>
          </div>
          <div v-else-if="isReturningUsersData">
            <barchart
              ref="returninguser"
              :chartData="returningusersdata"
              :width="width"
              :height="height"
              :options="returningusersoptions"
              :bind="true"
            ></barchart>
          </div>
          <div class="datanotfound" v-else>
            <h1>Sorry, Data not found.</h1>
          </div>
        </div>
      </div>
    </div>

    <div class="horizontalchart">
      <div class="cardheader">
        <strong>{{chart4}}</strong>
        <div class="downloadbtn">
          <a
            ref="downcsvLastclickVsAttributedModel"
            v-if="downcsvLastclickVsAttributedurl.length"
            v-bind:href="downcsvLastclickVsAttributedurl"
            class="btn btn-lrg btn-primary downcsvtrigger"
            download
          >
            <i class="fa fa-file-excel-o"></i> Download CSV
          </a>
        </div>
      </div>
      <div class="model-list subchannels-list" v-show="isShowChannels">
        <button
          @click="toggleChannelsModel()"
          rel="togglebtnsubchannels"
          class="btn toggle-model toggle-subchannels"
        >
          <span>
            <i class="fa fa-th-large" aria-hidden="true"></i>
          </span>
          <b>Select a sub channels</b>
        </button>

        <div class="dropdown-content subchannels-content hide-subchannels-content">
          <p
            v-on:click="selectedChannel('All Channels');toggleChannelsModel()"
            v-bind:class="channelSelected == 'All Channels' ? 'current-model' : ''"
          >All Channels</p>
          <p
            v-for="(subchannel, key) in flilteredsubchannellist"
            :key="key"
            v-bind:value="subchannel"
            v-on:click="selectedChannel(subchannel);toggleChannelsModel()"
            v-bind:class="subchannel == channelSelected ? 'current-model' : ''"
          >{{ subchannel}}</p>
        </div>
        <!-- <div class="model-name"><b>Selected Channel:</b> {{ subchannel }}</div> -->
      </div>
      <div class="card">
        <div class="dataspinner" v-if="isAssignedOrderCreditDataLoad">
          <div class="bounce1 makecenter"></div>
          <div class="bounce2 makecenter"></div>
          <div class="bounce3 makecenter"></div>
        </div>
        <div class="horizontalbar-charts" v-else-if="isAssignedOrderCreditData">
          <div class="horizontalbar-chart1">
            <horizontalchartbar
              ref="horizontalchartbar"
              :chartData="assignedordercreditdata"
              :width="width"
              :height="height"
              :options="horizontalchartoptions"
            ></horizontalchartbar>
          </div>
          <div class="horizontalbar-chart2">
            <horizontalchartbar
              ref="horizontalchartbar2"
              :chartData="assignedordercreditdata2"
              :width="width"
              :height="height"
              :options="horizontalchartoptions2"
            ></horizontalchartbar>
          </div>
        </div>
        <div class="datanotfound" v-else>
          <h1>Sorry, Data not found.</h1>
        </div>
      </div>
    </div>

    <div class="line-chart">
      <div class="cardheader">
        <strong>{{chart5}}</strong>
        <div class="downloadbtn">
          <a
            ref="downcsvWaterfallModel"
            v-if="downcsvWaterfallurl.length"
            v-bind:href="downcsvWaterfallurl"
            class="btn btn-lrg btn-primary downcsvtrigger"
            download
          >
            <i class="fa fa-file-excel-o"></i> Download CSV
          </a>
        </div>
      </div>
      <div class="card">
        <div class="dataspinner" v-if="iswaterfallChartDataLoad">
          <div class="bounce1 makecenter"></div>
          <div class="bounce2 makecenter"></div>
          <div class="bounce3 makecenter"></div>
        </div>
        <div v-else-if="iswaterfallChartData">
          <waterfallchart
            ref="waterfallchart"
            :chartData="waterfallJsonData"
            :width="width"
            :height="height"
            :options="waterfallOptions"
          ></waterfallchart>
        </div>
        <div class="datanotfound" v-else>
          <h1>Sorry, Data not found.</h1>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import linechart from './chartline.js'
import barchart from './chartbar.js'
import horizontalchartbar from './horizontalchartbar.js'
import waterfallchart from './waterfallchart.js'
import ChartJSPluginDatalabels from 'chartjs-plugin-datalabels'
import zoom from './chartjs-plugin-zoom/chartjs-plugin-zoom.js'
import Chart from 'chart.js'
Chart.defaults.global.plugins.datalabels.display = false
import ChartJSPluginAnnotation from 'chartjs-plugin-annotation'
import vueSlider from 'vue-slider-component'
var moment = require('moment')
var assignedordercreditjson = []
var samplejson = []
var touchpointjson = []
var returningusersjson = []
import $ from 'jquery'
export default {
  name: 'DashboardModule',
  components: {
    linechart,
    barchart,
    horizontalchartbar,
    ChartJSPluginDatalabels,
    ChartJSPluginAnnotation,
    waterfallchart,
    vueSlider,
    zoom
  },
  data: function () {
    return {
      touchpointAllusercheck: true,
      touchpointdata_all: [],
      touchpointdata_converted: [],
      newuserstouch: [],
      convereduserstouch: [],
      existing_channel_range: 'no',
      showbutton: 0,
      zoomed: false,
      slideroptions: {
        eventType: 'auto',
        direction: 'horizontal',
        height: 8,
        width: '80%',
        dotSize: 20,
        max: 100,
        min: 1,
        interval: 3,
        show: true,
        speed: 0.5,
        disabled: false,
        piecewise: true,
        piecewiseLabel: false,
        tooltip: 'always',
        tooltipDir: 'top',
        reverse: false,
        data: this.sliderData,
        clickable: true
      },
      sliderData: [],
      joblist: [],
      subchannellist: [],
      flilteredsubchannellist: [],
      subChannelsData: {},
      allSubChannelsData: {},
      isShowChannels: false,
      channelSelected: 'All Channels',
      currentjob: {},
      currentjobobj: {},
      chart1: 'Line Chart',
      chart2: 'Bar Chart',
      chart3: 'Bar Chart',
      chart4: 'Bar Chart',
      chart5: 'Waterfall chart',
      width: '80%',
      height: '400',
      startDate: '',
      endDate: '',
      downcsvWaterfallurl: '',
      downcsvLastclickVsAttributedurl: '',
      downcsvTouchpointHitsurl: '',
      downcsvLookbackurl: '',
      downcsvWebTrafficOverviewurl: '',
      textFontSize: 14,
      inchartdata: {},
      isInChartDataLoad: true,
      isInChartData: false,
      iswaterfallChartDataLoad: true,
      iswaterfallChartData: false,
      returningusersdata: {},
      isReturningUsersDataLoad: true,
      isReturningUsersData: false,
      assignedordercreditdata: {},
      assignedordercreditdata2: {},
      isAssignedOrderCreditDataLoad: true,
      isAssignedOrderCreditData: false,
      touchpointdata: {},
      waterfallJsonData: {},
      isTouchpointDataLoad: true,
      isTouchpointData: false,
      options: {},
      horizontalchartoptions: {},
      horizontalchartoptions2: {},
      chartoptions: {},
      returningusersoptions: {},
      waterfallOptions: {},
      client: this.$route.params.client ? this.$route.params.client : window.localStorage.getItem('last_client'),
      change_credit_negative_color: '',
      change_credit_positive_color: ''
    }
  },
  methods: {
    zoomTest () {
      console.log(this)
      this.$refs.linechart._chart.resetZoom()
      this.zoomed = false
    },
    // hex to rgb color conversion
    hexToRgbCode (hexcode, opacity) {
      var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i
      hexcode = hexcode.replace(shorthandRegex, function (m, r, g, b) {
        return r + r + g + g + b + b
      })
      var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hexcode)
      var arr = []
      arr.push(parseInt(result[1], 16))
      arr.push(parseInt(result[2], 16))
      arr.push(parseInt(result[3], 16))
      arr.push(opacity)
      return result ? 'rgb(' + arr + ')' : null
    },

    // Redirect to report page
    goToReports () {
      let uniqueId = this.$route.params.length ? this.$route.params.uid : window.localStorage.getItem('unique_id')
      let jobId = this.$route.params.length ? this.$route.params.jid : window.localStorage.getItem('jobid')
      window.localStorage.setItem('unique_id', uniqueId)
      window.localStorage.setItem('jobid', jobId)
      this.$router.replace('/Report')
    },
    CheckJobifshared () {
      let jid = window.localStorage.getItem('user')
      if (this.$route.params.job_owner !== window.localStorage.getItem('user')) {
        jid = this.$route.params.job_owner ? this.$route.params.job_owner : window.localStorage.getItem('job_owner')
      }
      if (!jid) {
        jid = window.localStorage.getItem('user')
      }
      return jid
    },

    // Historical model warning popup
    isDataFound () {
      let jobModifiedDate = window.localStorage.getItem('Job_last_modified') ? window.localStorage.getItem('Job_last_modified') : ''
      if (jobModifiedDate) {
        let dateTimeParts = jobModifiedDate.split(' ')
        let dateParts = dateTimeParts[0].split('-')
        let modifiedDate = dateParts[1] + '/' + dateParts[2] + '/' + dateParts[0]
        var modifiedTimestamp = new Date(modifiedDate).getTime()
      }

      var myDate = '15-01-2019'
      myDate = myDate.split('-')
      var newDate = myDate[1] + '/' + myDate[0] + '/' + myDate[2]
      let givenDateTimestamp = new Date(newDate).getTime()
      if (modifiedTimestamp <= givenDateTimestamp) {
        var self = this
        let obj = {
          title: 'Historical model',
          message: 'Data not available for historical models, please create new model.',
          type: 'warning',
          customClass: 'warning'
        }
        setTimeout(function () {
          self.$Simplert.open(obj)
        }, 500)
      }
    },

    arrangingData (jsondata) {
      if (jsondata.length) {
        var finaldata = {}
        var datasets = []
        // jsondata[0].ylabelvalue.forEach(function (e, i) {
        //   jsondata[0].ylabelvalue[i] = e.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        // })
        for (let valuesets in jsondata[0].chartdata) {
          if (valuesets !== 'bayesianVslast_click') {
            console.log(jsondata[0].chartdata[valuesets])
            jsondata[0].chartdata[valuesets].ylabelvalue.forEach(function (e, i) {
              console.log(e)
            })
            datasets.push({
              label: jsondata[0].chartdata[valuesets].label,
              fill: false,
              borderWidth: 2,
              borderColor: jsondata[0].chartdata[valuesets].color,
              pointBackgroundColor: jsondata[0].chartdata[valuesets].color,
              backgroundColor: this.hexToRgbCode(jsondata[0].chartdata[valuesets].color, 0.6),
              data: jsondata[0].chartdata[valuesets].ylabelvalue
            })
          }
        }
        finaldata.labels = jsondata[0].xlabelvalue
        // .toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
        finaldata.datasets = datasets
        return finaldata
      }
    },

    arrangingData2 (jsondata) {
      var JDdata
      var self = this
      if (jsondata.length || jsondata.chartdata) {
        if (jsondata[0]) {
          JDdata = jsondata[0]
        } else if (!jsondata[0]) {
          JDdata = jsondata
        }
        var finaldata = {}
        var datasets = []
        var bgColor = []
        var bordercolor = []
        if (jsondata.length) {
          for (let valuesets in JDdata.bayesianVslast_click) {
            if (JDdata.bayesianVslast_click[valuesets] > 0) {
              bordercolor.push(JDdata.change_credit_positive_color)
              bgColor.push(this.hexToRgbCode(JDdata.change_credit_positive_color, 0.6))
            } else {
              bordercolor.push(JDdata.change_credit_negative_color)
              bgColor.push(this.hexToRgbCode(JDdata.change_credit_negative_color, 0.6))
            }
          }
          datasets.push({
            label: 'Change in credit',
            fill: false,
            borderWidth: 2,
            borderColor: bordercolor,
            backgroundColor: bgColor,
            data: JDdata.bayesianVslast_click
          })
        }
        if (jsondata.chartdata) {
          JDdata.chartdata.bayesianVslast_click.forEach(function (e, i) {
            if (e > 0) {
              bordercolor.push(self.change_credit_positive_color)
              bgColor.push(self.hexToRgbCode(self.change_credit_positive_color, 0.6))
            } else {
              bordercolor.push(self.change_credit_negative_color)
              bgColor.push(self.hexToRgbCode(self.change_credit_negative_color, 0.6))
            }
          })
          datasets.push({
            label: 'Change in credit',
            fill: false,
            borderWidth: 2,
            borderColor: bordercolor,
            backgroundColor: bgColor,
            data: JDdata.chartdata.bayesianVslast_click
          })
        }
        finaldata.labels = JDdata.xlabelvalue
        finaldata.datasets = datasets
        return finaldata
      }
    },

    waterFallData (waterfall) {
      if (waterfall) {
        var self = this
        let waterfallJson = []
        let waterfallFinalJson = {}
        let aggregate = waterfall.aggregate
        let defecitOrSurplus = waterfall.defecit_or_surplus
        aggregate.forEach(function (value, index) {
          if (!index || index === (aggregate.length - 1)) {
            let dataarr = []
            if (!index) {
              dataarr.push(aggregate[index])
              for (let i = 0; i < aggregate.length - 1; i++) {
                dataarr.push(0)
              }
            } else {
              for (let i = 0; i < aggregate.length - 1; i++) {
                dataarr.push(0)
              }
              dataarr.push(Math.abs(aggregate[index]))
            }
            waterfallJson.push(
              {
                label: 'Value',
                data: dataarr,
                backgroundColor: self.hexToRgbCode(waterfall.first_and_last_color, 0.4)
              }
            )
          } else {
            let dummyStackArr = []
            let stackArr = []
            let colorCode = defecitOrSurplus[index] > 0 ? waterfall.positive_color : waterfall.negative_color
            for (let i = 0; i < index; i++) {
              dummyStackArr.push(0)
            }
            dummyStackArr.push(Math.abs(defecitOrSurplus[index]))
            for (let i = 0; i < aggregate.length - index - 1; i++) {
              dummyStackArr.push(0)
            }
            for (let i = 0; i < index; i++) {
              stackArr.push(0)
            }
            stackArr.push(Math.abs(aggregate[index]))
            for (let i = 0; i < aggregate.length - index - 1; i++) {
              stackArr.push(0)
            }
            waterfallJson.push(
              {
                label: 'Value',
                data: stackArr,
                waterfall: {
                  dummyStack: true
                },
                stack: 'stack ' + index
              }
            )
            waterfallJson.push(
              {
                label: 'Value',
                data: dummyStackArr,
                backgroundColor: colorCode,
                stack: 'stack ' + index
              }
            )
          }
        })
        waterfallFinalJson.labels = waterfall.Channel
        waterfallFinalJson.datasets = waterfallJson
        return waterfallFinalJson
      }
    },

    arrangingReturningUsersData (returningusersjson) {
      if (returningusersjson.length) {
        var finaldata = {}
        var datasets = []
        datasets.push({
          label: returningusersjson[0].label,
          fill: false,
          borderWidth: 2,
          borderColor: returningusersjson[0].color,
          pointBackgroundColor: returningusersjson[0].color,
          backgroundColor: this.hexToRgbCode(returningusersjson[0].color, 0.6),
          data: returningusersjson[0].ylabelvalue
        })
        finaldata.labels = returningusersjson[0].xlabelvalue
        finaldata.datasets = datasets
        return finaldata
      }
    },

    // API call for getting all job id user have
    getUserJobeList () {
      var self = this
      $.ajax({
        type: 'POST',
        url: window.localStorage.getItem('ApiURL') + '/JobStatusCheck',
        data: {
          user: window.localStorage.getItem('user'),
          required: 'name, user, status',
          filter: '{"status":"completed"}'
        },
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        beforeSend: function () {
          self.$pingpong.displayLoader()
          $('.spinner').css({ top: '14%' })
        },
        success: function (data) {
          self.$pingpong.hideloader()
          let datalist = JSON.parse(data['job_status_data'])
          self.joblist = datalist
          let currentjobid = window.localStorage.getItem('jobid')
          let preselectedjob = self.joblist.find(x => x.id === currentjobid)
          self.currentjobobj = preselectedjob
        },
        error: function (data, error) {
          console.log(data)
          console.log(error)
        }
      })
    },

    selectedJob (selectedjobid) {
      this.existing_channel_range = 'no'
      this.isShowChannels = false
      this.channelSelected = 'All Channels'
      let iscallapi = selectedjobid === window.localStorage.getItem('jobid')
      if (!iscallapi) {
        this.isInChartDataLoad = true
        this.iswaterfallChartDataLoad = true
        this.isReturningUsersDataLoad = true
        this.isAssignedOrderCreditDataLoad = true
        this.isTouchpointDataLoad = true
        let selectedjob = this.joblist.find(x => x.id === selectedjobid)
        this.currentjobobj = selectedjob
        window.localStorage.setItem('jobid', selectedjob.id)
        window.localStorage.setItem('unique_id', selectedjob.unique_id)
        window.localStorage.setItem('job_owner', selectedjob.user)
        this.waterfallCredit()
        this.webTrafficOverview()
        this.assignedOrderCredit()
        this.touchpointHits()
        this.returningUser()
      }
    },

    // API call for "Direct/Organic - movement under last click, credit source"
    waterfallCredit () {
      var self = this
      var jdata = {
        'username': this.CheckJobifshared(),
        'job_id': window.localStorage.getItem('jobid'),
        'unique_id': window.localStorage.getItem('unique_id')
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/GetWaterfallChartData',
        data: JSON.stringify(jdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        success: function (data) {
          self.downcsvWaterfallurl = data.fileurl ? data.fileurl : ''
          let waterfalljson = data['touchpoint_data'] ? data['touchpoint_data'][0] : []
          self.chart5 = waterfalljson ? waterfalljson.chart_name : ''
          let minaggregate = waterfalljson['aggregate']
          let minWaterfallValue = []
          for (let valuesets in minaggregate) {
            if (minaggregate[valuesets]) {
              minWaterfallValue.push(Math.abs(minaggregate[valuesets]))
            }
          }
          self.waterfallOptions = {
            scales: {
              yAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: waterfalljson ? waterfalljson.y_axis_name : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }

                  },
                  ticks: {
                    fontSize: self.textFontSize,
                    min: Math.min.apply(this, minWaterfallValue) * 99 / 100,
                    callback: function (value, index, values) {
                      if (parseInt(value) > 999) {
                        return '' + Math.floor(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else if (parseInt(value) < -999) {
                        return '' + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else {
                        return '' + value
                      }
                    }
                  }
                }
              ],
              xAxes: [
                {
                  display: true,
                  barPercentage: waterfalljson.Channel ? waterfalljson.Channel.length * 2 + 1 : '',
                  // barPercentage: 23,
                  scaleLabel: {
                    display: false,
                    labelString: waterfalljson.length ? waterfalljson[0].x_axis_name : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ]
            },
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            legend: {
              display: false,
              labels: {
                fontSize: self.textFontSize
              }
            },
            plugins: {
              datalabels: {
                display: true,
                color: '#000000',
                formatter: function (value) {
                  return value
                },
                font: {
                  size: self.textFontSize
                }
              }
            },
            tooltips: {
              // mode: 'index',
              // intersect: false,
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: 14,
              bodyFontSize: 14,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] !== 0 ? ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : ''
                }
              }
            }
          }

          self.iswaterfallChartDataLoad = false
          if (data['Error'] || data['errorMessage'] || waterfalljson === {}) {
            self.chart5 = 'Waterfall chart'
            self.iswaterfallChartData = false
          } else {
            self.waterfallJsonData = self.waterFallData(waterfalljson)
            self.iswaterfallChartData = true
          }
        },
        error: function (data, error) {
          console.log('Error data : ', data)
          console.log('Error message : ', error)
          self.waterfalljson = []
          self.chart5 = 'Waterfall chart'
          self.iswaterfallChartDataLoad = false
          self.iswaterfallChartData = false
        }
      })
    },

    // API call for "Assigned order credit Last Click Vs Attributed"
    assignedOrderCredit () {
      var self = this
      var jdata = {
        'username': this.CheckJobifshared(),
        'job_id': window.localStorage.getItem('jobid'),
        'unique_id': window.localStorage.getItem('unique_id')
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/GetLastClickVsAttributedChartData',
        data: JSON.stringify(jdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        success: function (data) {
          self.downcsvLastclickVsAttributedurl = data.fileurl ? data.fileurl : ''
          assignedordercreditjson = data.credit_data ? data.credit_data : []
          self.subchannellist = assignedordercreditjson.length ? assignedordercreditjson[0].xlabelvalue : ''
          self.flilteredsubchannellist = assignedordercreditjson.length ? assignedordercreditjson[0].channel_with_subchannels : ''
          self.chart4 = assignedordercreditjson.length ? assignedordercreditjson[0].Chart_Label : ''
          self.isShowChannels = assignedordercreditjson.length
          self.subChannelsData = assignedordercreditjson.length ? assignedordercreditjson[0].subChannels : []
          self.allSubChannelsData = assignedordercreditjson
          self.change_credit_positive_color = assignedordercreditjson[0].change_credit_positive_color
          self.change_credit_negative_color = assignedordercreditjson[0].change_credit_negative_color
          self.horizontalchartoptions = {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            tooltips: {
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: self.textFontSize,
              bodyFontSize: self.textFontSize,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + Math.floor(data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index]).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            },
            legend: {
              labels: {
                fontSize: self.textFontSize
              }
            },
            scales: {
              yAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: assignedordercreditjson.length ? assignedordercreditjson[0].ylabel : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }
                  },
                  ticks: {
                    fontSize: self.textFontSize
                    // callback: function (value, index, values) {
                    //   if (parseInt(value) > 999) {
                    //     return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    //   } else if (parseInt(value) < -999) {
                    //     return '-$' + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                    //   } else {
                    //     return '$' + value
                    //   }
                    // }
                  }
                }
              ],
              xAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: assignedordercreditjson.length ? assignedordercreditjson[0].xlabel : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ]
            }
          }
          self.horizontalchartoptions2 = {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            annotation: {
              annotations: [
                {
                  type: 'line',
                  mode: 'vertical',
                  scaleID: 'x-axis-0',
                  value: 0,
                  borderColor: '#D3D3D3',
                  borderWidth: 1
                }
              ]
            },
            plugins: {
              datalabels: {
                display: true,
                color: '#000000',
                formatter: function (value) {
                  return value + '%'
                },
                font: {
                  size: self.textFontSize
                }
              }
            },
            tooltips: {
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: self.textFontSize,
              bodyFontSize: self.textFontSize,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%'
                }
              }
            },
            legend: {
              display: false,
              labels: {
                fontSize: self.textFontSize
              }
            },
            title: {
              display: true,
              text: 'Change in Assigned Credit',
              fontSize: self.textFontSize
            },
            scales: {
              yAxes: [
                {
                  display: false,
                  scaleLabel: {
                    display: true,
                    labelString: assignedordercreditjson.length ? assignedordercreditjson[0].ylabel : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ],
              xAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: 'Percentage change in credit (%)',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ]
            }
          }
          self.isAssignedOrderCreditDataLoad = false
          if (data['Error'] || data['errorMessage'] || !(assignedordercreditjson.length)) {
            self.chart4 = 'Bar Chart'
            self.isAssignedOrderCreditData = false
            self.isShowChannels = false
          } else {
            self.assignedordercreditdata = self.arrangingData(assignedordercreditjson)
            self.assignedordercreditdata2 = self.arrangingData2(assignedordercreditjson)
            self.isAssignedOrderCreditData = true
          }
        },
        error: function (data, error) {
          console.log('Error data : ', data)
          console.log('Error message : ', error)
          self.assignedordercreditjson = []
          self.chart4 = 'Bar Chart'
          self.isAssignedOrderCreditDataLoad = false
          self.isAssignedOrderCreditData = false
          self.isShowChannels = false
        }
      })
    },

    // API call for "New Vs Returning Touchpoint hits"
    touchpointHits () {
      var self = this
      var jdata = {
        'username': this.CheckJobifshared(),
        'job_id': window.localStorage.getItem('jobid'),
        'unique_id': window.localStorage.getItem('unique_id')
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/GetNewVsReturningTouchpointHitsChartData',
        data: JSON.stringify(jdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        success: function (data) {
          if (data.Error) {
            console.log('Error data : ', data)
            console.log('Error message : ', data.Error)
            self.touchpointjson = []
            self.chart2 = 'Bar Chart'
            self.isTouchpointDataLoad = false
            self.isTouchpointData = false
            return false
          }
          self.downcsvTouchpointHitsurl = data.fileurl ? data.fileurl : ''
          if (data.touchpoint_data.length) {
            touchpointjson[1] = data.touchpoint_data[0].converted
            touchpointjson[0] = data.touchpoint_data[0].all
          }
          console.log(data)
          self.touchpointdata_all[0] = data.touchpoint_data[0].all
          self.touchpointdata_converted[0] = data.touchpoint_data[0].converted
          self.chart2 = touchpointjson.length ? touchpointjson[0].Chart_Label : ''
          self.touchpointAllusercheck = true
          self.chartoptions = {
            responsive: true,
            maintainAspectRatio: false,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            animation: {
              duration: 1000,
              easing: 'linear'
            },
            tooltips: {
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: self.textFontSize,
              bodyFontSize: self.textFontSize,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index] + '%'
                }
              }
            },
            legend: {
              labels: {
                fontSize: self.textFontSize
              }
            },
            scales: {
              yAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: touchpointjson.length ? touchpointjson[0].ylabel + ' (In percentage)' : '',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ],
              xAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: touchpointjson.length ? touchpointjson[0].xlabel : '',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  },
                  barPercentage: 1
                }
              ]
            },
            pan: {
              // Boolean to enable panning
              enabled: false,
              speed: 7,
              threshold: 2,
              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: 'x'
            },
            // Container for zoom options
            zoom: {
              // Boolean to enable zooming
              enabled: false,
              drag: false,
              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: 'xy'
            }
          }
          self.isTouchpointDataLoad = false
          if (data['Error'] || data['errorMessage'] || !(touchpointjson.length)) {
            self.chart2 = 'Bar Chart'
            self.isTouchpointData = false
          } else {
            // self newusers
            // self.newuserstouch = []
            // self.convereduserstouch = []
            // self.newuserstouch.push(touchpointjson[0].chartdata.converted_new_users)
            // self.newuserstouch.push(touchpointjson[0].chartdata.new_users)
            // self.convereduserstouch.push(touchpointjson[0].chartdata.converted_new_users)
            // self.convereduserstouch.push(touchpointjson[0].chartdata.converted_new_users)
            self.touchpointdata = self.arrangingData(touchpointjson)
            self.isTouchpointData = true
          }
        },
        error: function (data, error) {
          console.log('Error data : ', data)
          console.log('Error message : ', error)
          self.touchpointjson = []
          self.chart2 = 'Bar Chart'
          self.isTouchpointDataLoad = false
          self.isTouchpointData = false
        }
      })
    },

    // API call for "Web Traffic Overview"
    webTrafficOverview () {
      var timeFormat = 'YYYY/MM/DD'
      var self = this
      var __root = this
      var jdata = {
        'market': this.$route.params.market ? this.$route.params.market : window.localStorage.getItem('last_Market'),
        'client': this.$route.params.client ? this.$route.params.client : window.localStorage.getItem('last_client'),
        'unique_id': window.localStorage.getItem('unique_id')
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/VoyagerHitsVSChannel',
        data: JSON.stringify(jdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        success: function (data) {
          self.downcsvWebTrafficOverviewurl = data.fileurl ? data.fileurl : ''
          samplejson = data['json-data'] ? JSON.parse(data['json-data']) : []
          self.chart1 = samplejson.length ? samplejson[0].Chart_Label : ''
          var myarray = samplejson.length ? samplejson[0].xlabelvalue : ''
          var mydatearray = []
          if (myarray) {
            myarray.forEach(function (e, i) {
              let val = moment(e, 'YYYY-MM-DD').format('YYYY-MM-DD')
              mydatearray.push(val)
            })
            samplejson[0].xlabelvalue = mydatearray
          }
          // console.log(mydatearray)
          self.sliderData = mydatearray
          self.startDate = samplejson.length ? samplejson[0].xlabelvalue[0] : ''
          self.endDate = samplejson.length ? samplejson[0].xlabelvalue[(samplejson[0].xlabelvalue.length - 1)] : ''
          self.options = {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            pan: {
              // Boolean to enable panning
              enabled: true,
              speed: 700,
              threshold: 10,
              // Panning directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow panning in the y direction
              mode: 'x',
              rangeMin: {
                // Format of min pan range depends on scale type
                x: 10,
                y: 20
              },
              rangeMax: {
                // Format of max pan range depends on scale type
                x: 100,
                y: 200
              }
              // Function called once panning is completed
              // Useful for dynamic data loading
              // onPan: function () { console.log(this) }
            },
            zoom: {
              // Boolean to enable zooming
              enabled: true,
              // drag: true,
              speed: 700,
              dragOptions: {
                borderColor: 'rgba(225,225,5,1)',
                borderWidth: 5,
                backgroundColor: 'rgb(46, 138, 138)'
              },
              // sensitivity: 40,
              // limits: {
              //   max: 2000,
              //   min: 200
              // },
              // Drag-to-zoom rectangle style can be customized
              drag: {
                enabled: true,
                borderColor: 'rgba(225,225,5,1)',
                borderWidth: 5,
                backgroundColor: 'rgb(46, 138, 138)'
              },

              // Zooming directions. Remove the appropriate direction to disable
              // Eg. 'y' would only allow zooming in the y direction
              mode: 'xy',
              // rangeMin: {
              //   // Format of min zoom range depends on scale type
              //   x: 100,
              //   y: 100
              // },
              // rangeMax: {
              //   // Format of max zoom range depends on scale type
              //   x: 1000000000,
              //   y: 1000000000
              // },
              // Function called once zooming is completed
              // Useful for dynamic data loading
              onClick: function (e) {
                console.log(e)
                // debugger
              },
              onZoom: function () {
                __root.zoomed = true
                // debugger
              }
            },
            tooltips: {
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: self.textFontSize,
              bodyFontSize: self.textFontSize,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            },
            // plugins: {
            //   crosshair: {
            //     line: {
            //       color: '#F66',  // crosshair line color
            //       width: 2        // crosshair line width
            //     },
            //     sync: {
            //       enabled: false            // enable trace line syncing with other charts
            //     },
            //     zoom: {
            //       enabled: false,                                      // enable zooming
            //       zoomboxBackgroundColor: 'rgba(66,133,244,0.2)',     // background color of zoom box
            //       zoomboxBorderColor: '#48F',                         // border color of zoom box
            //       zoomButtonText: 'Reset Zoom',                       // reset zoom button text
            //       zoomButtonClass: 'reset-zoom'                      // reset zoom button class
            //     },
            //     callbacks: {
            //       beforeZoom: function (start, end, chart) {
            //         console.log(start, end, chart)               // called before zoom, return false to prevent zoom
            //         return true
            //       },
            //       afterZoom: function (start, end) {                   // called after zoom
            //         console.log(start, end)
            //       }
            //     }
            //   }
            // },
            legend: {
              labels: {
                fontSize: self.textFontSize
              }
            },
            scales: {
              yAxes: [
                {

                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: samplejson.length ? samplejson[0].ylabel : '',
                    fontSize: self.textFontSize,
                    scaleLabel: function (label) { return '' + label.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') }
                  },
                  ticks: {
                    fontSize: self.textFontSize,
                    callback: function (value, index, values) {
                      if (parseInt(value) > 999) {
                        return '' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else if (parseInt(value) < -999) {
                        return '' + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else {
                        return '' + value
                      }
                    }
                  }
                }
              ],
              xAxes: [
                {
                  type: 'time',
                  distribution: 'linear',
                  time: {
                    parser: timeFormat,
                    round: 'day',
                    unit: 'day',
                    // tooltipFormat: 'll HH:mm',
                    displayFormats: {
                      quarter: 'YYYY MM DD'
                    }
                  },
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: samplejson.length ? samplejson[0].xlabel : '',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  }
                }
              ]
            }
            /* title: {
              display: true,
              text: samplejson[0].Chart_Label,
              fontSize: 15
            } */
          }
          self.isInChartDataLoad = false
          if (data['Error'] || data['errorMessage'] || !(samplejson.length)) {
            self.chart1 = 'Line Chart'
            self.isInChartData = false
          } else {
            self.inchartdata = self.arrangingData(samplejson)
            self.isInChartData = true
          }
        },
        error: function (data, error) {
          console.log('Error data : ', data)
          console.log('Error message : ', error)
          self.samplejson = []
          self.chart1 = 'Line Chart'
          self.isInChartDataLoad = false
          self.isInChartData = false
        }
      })
    },

    // API call for "Returning Journeys Lookback"
    returningUser () {
      var self = this
      var jdata = {
        'username': this.CheckJobifshared(),
        'job_id': window.localStorage.getItem('jobid'),
        'unique_id': window.localStorage.getItem('unique_id')
      }
      $.ajax({
        type: 'POST',
        url:
          window.localStorage.getItem('ApiURL') +
          '/VoyagerReturningUserSessions',
        data: JSON.stringify(jdata),
        async: true,
        contentType: 'application/json',
        headers: {
          'x-api-key': window.localStorage.getItem('XpiKey')
        },
        success: function (data) {
          self.downcsvLookbackurl = data.fileurl ? data.fileurl : ''
          returningusersjson = data['json-data'] ? JSON.parse(data['json-data']) : []
          if (returningusersjson.length) {
            self.showbutton = returningusersjson[0].ylabelvalue.length === 32 ? returningusersjson[0].ylabelvalue.length : 0
          }
          self.chart3 = returningusersjson.length ? returningusersjson[0].Chart_Label : ''
          self.returningusersoptions = {
            responsive: true,
            maintainAspectRatio: false,
            aspectRatio: 2,
            layout: {
              padding: {
                left: 5,
                right: 5,
                top: 10,
                bottom: 10
              }
            },
            tooltips: {
              titleFontColor: '#000000',
              bodyFontColor: '#000000',
              titleFontSize: self.textFontSize,
              bodyFontSize: self.textFontSize,
              backgroundColor: '#ffffff',
              borderWidth: 2,
              borderColor: '#D3D3D3',
              xPadding: 14,
              yPadding: 10,
              bodySpacing: 3,
              callbacks: {
                label: function (tooltipItems, data) {
                  return ' ' + data.datasets[tooltipItems.datasetIndex].label + ' : ' + data.datasets[tooltipItems.datasetIndex].data[tooltipItems.index].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                }
              }
            },
            legend: {
              labels: {
                fontSize: self.textFontSize
              }
            },
            scales: {
              yAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: returningusersjson.length ? returningusersjson[0].ylabel : '',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize,
                    callback: function (value, index, values) {
                      if (parseInt(value) > 999) {
                        return '' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else if (parseInt(value) < -999) {
                        return '' + Math.abs(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                      } else {
                        return '' + value
                      }
                    }
                  }
                }
              ],
              xAxes: [
                {
                  display: true,
                  scaleLabel: {
                    display: true,
                    labelString: returningusersjson.length ? returningusersjson[0].xlabel : '',
                    fontSize: self.textFontSize
                  },
                  ticks: {
                    fontSize: self.textFontSize
                  },
                  barPercentage: 1
                }
              ]
            }
          }
          self.isReturningUsersDataLoad = false
          if (data['Error'] || data['errorMessage'] || !(returningusersjson.length)) {
            self.chart3 = 'Bar Chart'
            self.isReturningUsersData = false
          } else {
            self.returningusersdata = self.arrangingReturningUsersData(returningusersjson)
            self.isReturningUsersData = true
          }
        },
        error: function (data, error) {
          console.log('Error data : ', data)
          console.log('Error message : ', error)
          self.returningusersjson = []
          self.chart3 = 'Bar Chart'
          self.isReturningUsersDataLoad = false
          self.isReturningUsersData = false
        }
      })
    },

    toggleModel () {
      let activeclass = document.getElementsByClassName('dropdown-content hide-model-content').length
      let element = document.getElementsByClassName('dropdown-content')[0]
      let btnactive = document.getElementsByClassName('toggle-model')[0]
      if (activeclass) {
        element.classList.remove('hide-model-content')
        element.classList.add('show-model-content')
        btnactive.classList.add('active-btn')
      } else {
        element.classList.remove('show-model-content')
        element.classList.add('hide-model-content')
        btnactive.classList.remove('active-btn')
      }
    },

    closeToggleModel () {
      let activeclass = document.getElementsByClassName('dropdown-content hide-model-content').length
      let element = document.getElementsByClassName('dropdown-content')[0]
      let btnactive = document.getElementsByClassName('toggle-model')[0]
      if (!activeclass) {
        element.classList.remove('show-model-content')
        element.classList.add('hide-model-content')
        btnactive.classList.remove('active-btn')
      }
    },

    fifteenDaysData () {
      let fifteendata = 0
      let fifteendaysjson = []
      fifteendaysjson[0] = {}
      for (var keys in returningusersjson[0]) {
        fifteendaysjson[0][keys] = returningusersjson[0][keys]
      }
      fifteendaysjson[0].xlabelvalue = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, '15+']
      fifteendaysjson[0].ylabelvalue = []
      for (var value in returningusersjson[0].ylabelvalue) {
        if (value < 16) {
          fifteendaysjson[0].ylabelvalue.push(returningusersjson[0].ylabelvalue[value])
        } else {
          fifteendata = fifteendata + returningusersjson[0].ylabelvalue[value]
        }
      }
      fifteendaysjson[0].ylabelvalue.push(fifteendata)
      this.returningusersdata = this.arrangingReturningUsersData(fifteendaysjson)
      this.existing_channel_range = 'yes'
    },
    touchpointAlluser () {
      this.touchpointdata = this.arrangingData(this.touchpointdata_all)
      this.touchpointAllusercheck = true
    },
    touchpointReturninguser () {
      this.touchpointdata = this.arrangingData(this.touchpointdata_converted)
      this.touchpointAllusercheck = false
    },
    thirtyDaysData () {
      this.returningusersdata = this.arrangingReturningUsersData(returningusersjson)
      this.existing_channel_range = 'no'
    },

    toggleChannelsModel () {
      let activeclass = document.getElementsByClassName('subchannels-content hide-subchannels-content').length
      let element = document.getElementsByClassName('subchannels-content')[0]
      let btnactive = document.getElementsByClassName('toggle-subchannels')[0]
      if (activeclass && element) {
        element.classList.remove('hide-subchannels-content')
        element.classList.add('show-subchannels-content')
        btnactive.classList.add('active-btn')
      } else {
        element.classList.remove('show-subchannels-content')
        element.classList.add('hide-subchannels-content')
        btnactive.classList.remove('active-btn')
      }
    },

    closeToggleSubchannels () {
      let activeclass = document.getElementsByClassName('subchannels-content hide-subchannels-content').length
      let element = document.getElementsByClassName('subchannels-content')[0]
      let btnactive = document.getElementsByClassName('toggle-subchannels')[0]
      if (!activeclass && element) {
        element.classList.remove('show-subchannels-content')
        element.classList.add('hide-subchannels-content')
        btnactive.classList.remove('active-btn')
      }
    },

    selectedChannel (subchannel) {
      this.channelSelected = subchannel
      if (subchannel === 'All Channels') {
        this.assignedordercreditdata = this.arrangingData(this.allSubChannelsData)
        this.assignedordercreditdata2 = this.arrangingData2(this.allSubChannelsData)
      } else {
        let selectedData = []
        selectedData.push(this.subChannelsData[subchannel])
        this.assignedordercreditdata = this.arrangingData(selectedData)
        let subchannelCreditpercent = this.subChannelsData[subchannel]
        this.assignedordercreditdata2 = this.arrangingData2(subchannelCreditpercent)
      }
    }
  },
  computed: {
    isMobile () {
      return window.innerWidth <= 800 && window.innerHeight <= 600
    }
  },
  mounted () {
    this.getUserJobeList()
    this.waterfallCredit()
    this.webTrafficOverview()
    this.assignedOrderCredit()
    this.touchpointHits()
    this.returningUser()
    this.isDataFound()
    let element = document.getElementsByClassName('dashboard-charts')[0].parentNode.parentNode
    element.addEventListener('click', this.closeToggleModel)
    let btnactive = document.getElementsByClassName('toggle-model')[0]
    btnactive.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    })

    element.addEventListener('click', this.closeToggleSubchannels)
    let subchannelsbtnactive = document.getElementsByClassName('toggle-subchannels')[0]
    subchannelsbtnactive.addEventListener('click', function (e) {
      e.preventDefault()
      e.stopPropagation()
      return false
    })
  },
  watch: {
    route: function (to, from) {
      console.log(this)
    }
  }
}
</script>
<style lang="scss">
.dashboard-charts {
  .togglebutton2 span:nth-child(even) label {
    width: 90px;
  }
  .togglebutton2 span:nth-child(odd) label {
    width: 49px;
  }
  .client-banner-justeat,
  .client-banner-matalan {
    width: 95%;
    margin: 20px 2.5% 0;
    background-size: cover;
    height: 200px;
    background-position: center center;
  }
  .client-banner-justeat {
    background-image: url(~/static/img/justeat.jpg);
  }
  .client-banner-matalan {
    background-image: url(~/static/img/matlan.jpg);
  }
  .csv-reports span {
    float: right;
    font-size: 18px;
    cursor: pointer;
    margin-top: 0px;
    line-height: 45px;
  }
  .csv-reports .chevron-right-icon {
    margin-left: 5px;
  }
  .card,
  .bar-chart {
    transition: 0.3s;
    width: 95%;
    margin: 0 2.5%;
    padding: 10px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    background: #ffffff;
  }
  .line-chart .line-chart-header {
    margin-top: 35px;
  }
  .cardheader {
    width: 95%;
    margin: 0 2.5%;
    padding: 10px;
    margin-top: 50px;
    font-size: 18px;
    border: 1px solid rgba(0, 0, 0, 0.3);
    border-bottom: none;
    box-shadow: inset 0px -1px 4px 1px rgba(201, 201, 201, 0.4);
    color: #666;
    background: #f5f5f5;
  }
  canvas {
    width: 100% !important;
    height: 500px !important;
  }
  .horizontalbar-chart1 {
    width: 70% !important;
  }
  .horizontalbar-chart2 {
    width: 30% !important;
  }
  .horizontalbar-charts {
    display: flex;
  }
  .horizontalchart canvas {
    height: 750px !important;
  }
  .chartrow {
    display: inline-flex;
    width: 95%;
    margin: 0 2.5%;
  }
  .chartrow .bar-chart,
  .chartrow .cardheader {
    width: 100%;
    margin-left: 0;
  }
  .chartrow .column {
    width: 49%;
  }
  .column:first-child {
    margin-right: 2%;
  }
  .dataspinner {
    display: flex;
    position: initial;
    width: 400px;
  }
  .dataspinner::after {
    position: initial;
    background: none;
  }
  .horizontalchart .dataspinner,
  .horizontalchart .datanotfound {
    height: 750px;
  }
  .line-chart .dataspinner,
  .line-chart .datanotfound,
  .chartrow .dataspinner,
  .chartrow .datanotfound {
    height: 500px;
  }
  .datanotfound {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .makecenter {
    position: relative;
    top: 40%;
    left: 40%;
  }
  .downcsvtrigger {
    font-size: 14px;
    background-color: #444;
    border-color: #444;
  }
  .downloadbtn {
    display: inline-flex;
    float: right;
    margin-top: -4px;
  }

  .csv-reports {
    display: inline;
  }
  select.form-control {
    background: rgba(167, 195, 94, 0.5);
    color: #000;
  }
  .dropdown-content {
    margin-top: 5px;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 160px;
    overflow: auto;
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
    z-index: 1;
    border: 1px solid #9e9e9e;
    border-radius: 0px 0px 5px 5px;
  }
  .dropdown-content p {
    cursor: pointer;
    margin: 0;
    padding: 10px 40px 10px 10px;
    border-bottom: 1px solid #9e9e9e;
  }
  .dropdown-content p:hover {
    background-color: #444;
    color: #fff;
  }
  .dropdown-content p:last-child {
    border-bottom: none;
  }
  .show-model-content,
  .show-subchannels-content {
    display: block;
  }
  .hide-model-content,
  .hide-subchannels-content {
    display: none;
  }
  .model-list {
    width: 95%;
    margin: 0 2.5%;
    margin-top: 20px;
  }
  .model-name {
    display: inline;
    font-size: 24px;
    width: 80%;
    position: absolute;
    text-align: center;
    font-weight: 600;
    line-height: 45px;
  }
  .current-model {
    background: #ededed;
    box-shadow: inset 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
    &::after {
      content: '\F00C';
      font: normal normal normal 14px/1 FontAwesome;
      position: absolute;
      right: 10px;
      padding-top: 3px;
    }
  }
  .toggle-model.active-btn span,
  .toggle-subchannels.active-btn span {
    background: #444;
  }
  .toggle-model.active-btn,
  .toggle-subchannels.active-btn {
    &:hover b {
      background: #444;
    }
  }
  .toggle-model,
  .toggle-subchannels {
    position: relative;
    background: none;

    span {
      padding: 12px 15px;
      background: #9fc54c;
      font-size: 20px;
      color: #fff;
      border-radius: 30px;
      z-index: 20;
      box-shadow: 0 2px 5px 1px rgba(0, 0, 0, 0.2);
    }
    b {
      opacity: 0;
      position: absolute;
      left: 0px;
      top: 5px;
      transition: All 0.4s ease-in-out;
      transform: rotate(0deg) scale(0) skew(0deg) translate(0px);
      z-index: 1;
    }
    &:hover b {
      opacity: 1;
      display: block;
      padding: 5px;
      background: #9fc54c;
      border-radius: 4px;
      color: #fff;
      left: 0px;
      transition: All 0.2s ease-in-out;
      transform: rotate(0deg) scale(1) skew(0deg) translate(45px);
    }
  }

  .togglebutton {
    position: absolute;
    right: 16px;
    top: 25px;
  }
  .togglebutton input {
    margin: 0;
    padding: 0;
    position: absolute;
    border: 0;
    height: 0;
    width: 0;
  }
  .togglebutton span {
    position: relative;
  }
  .togglebutton input + label {
    display: inline-block;
    margin: 0;
    padding: 0 12px;
    background: #e2e2e2;
    line-height: 30px;
    position: relative;
    width: 71px;
    color: #444;
    font-weight: 600;
  }
  .togglebutton input:checked + label {
    background: #9fc54c;
  }

  .togglebutton span:first-child label {
    border-radius: 5px 0px 0px 5px;
  }

  .togglebutton span:nth-child(even) label {
    border-radius: 0px 5px 5px 0px;
    margin-left: -1px;
  }

  .togglebutton2 {
    position: absolute;
    right: 16px;
    top: 25px;
  }
  .togglebutton2 input {
    margin: 0;
    padding: 0;
    position: absolute;
    border: 0;
    height: 0;
    width: 0;
  }
  .togglebutton2 span {
    position: relative;
  }
  .togglebutton2 input + label {
    display: inline-block;
    margin: 0;
    padding: 0 12px;
    background: #e2e2e2;
    line-height: 30px;
    position: relative;
    width: 71px;
    color: #444;
    font-weight: 600;
  }
  .togglebutton2 label.active {
    background: #9fc54c;
  }

  .togglebutton2 span:first-child label {
    border-radius: 5px 0px 0px 5px;
  }

  .togglebutton2 span:nth-child(even) label {
    border-radius: 0px 5px 5px 0px;
    margin-left: -1px;
  }

  .bar-chart-withbtn {
    position: relative;
  }

  .subchannels-list {
    position: absolute;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// DashboardModule.vue?3ede5a83